import {
    FETCH_ALL_CONSOLIDATED_PRODUCT_DETAIL_REQUEST,
    FETCH_ALL_CONSOLIDATED_PRODUCT_DETAIL_SUCCESS,
    FETCH_ALL_CONSOLIDATED_PRODUCT_DETAIL_FAILED,
    FETCH_ALL_CONSOLIDATED_PRODUCTS_REQUEST,
    FETCH_ALL_CONSOLIDATED_PRODUCTS_SUCCESS,
    FETCH_ALL_CONSOLIDATED_PRODUCTS_FAILED
} from './mutation-type'

const mutations = {
    [FETCH_ALL_CONSOLIDATED_PRODUCT_DETAIL_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_ALL_CONSOLIDATED_PRODUCT_DETAIL_SUCCESS]: (state, { status, data }) => {
        state.status = status
        if (status === 204) {
            state.productDetail = []
        } else {
            state.productDetail = data?.data.map(item => {
                const sortedProduct = item.product.sort((a, b) => b.cost - a.cost)
                return {
                    ...item,
                    product: sortedProduct
                }
            }).sort((a, b) => b.subTotal - a.subTotal) || []
        }
    },
    [FETCH_ALL_CONSOLIDATED_PRODUCT_DETAIL_FAILED]: (state, error) => {
        state.status = 'error'
    },
    [FETCH_ALL_CONSOLIDATED_PRODUCTS_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_ALL_CONSOLIDATED_PRODUCTS_SUCCESS]: (state, { status, data }) => {
        state.status = status
        if (status === 204) {
            state.products = []
            state.productDetail = []
        } else {
            const productByCost = data?.data.reduce((acc, cur) => {
                cur.product.forEach((subItem) => {
                    if (!acc[subItem.productCode]) acc[subItem.productCode] = 0
                    acc[subItem.productCode] += subItem.cost
                })
                return acc
            }, {}) ?? []
            state.products = Object
                .entries(productByCost)
                .map(([productCode, cost]) => ({ productCode, cost }))
                .sort((a, b) => b.cost - a.cost)

            state.productDetail = data?.data.map(item => {
                const sortedProduct = item.product.sort((a, b) => b.cost - a.cost)
                return {
                    ...item,
                    product: sortedProduct
                }
            }).sort((a, b) => b.subTotal - a.subTotal) || []
        }
    },
    [FETCH_ALL_CONSOLIDATED_PRODUCTS_FAILED]: (state, error) => {
        state.status = 'error'
    }
}

export default mutations
